import mapperBoolean from '../../../core/data-layer/utils/mappers/mapper-boolean'
import { mapperModuleMedia } from '../../../core/data-layer/modules/mappers'
import mapperGlobalDataPaymentMethodType from '../../../core/data-layer/global-data/global-data-payment-method-type/mapper-global-data-payment-method-type'
import mapperGlobalDataCurrency from '../../../core/data-layer/global-data/global-data-currency/mapper-global-data-currency'
import mapperPaymentsPaymentSubmethod from './mapper-payments-payment-submethod'
import type { MapperOptions, ModuleMedia } from '#layers/core/types'

const getCurrencies = (data: any[], isAll: boolean, currencies: any[] = []) => {
  if (isAll) {
    return currencies?.map(mapperGlobalDataCurrency)
  }
  return data?.map(mapperGlobalDataCurrency) || []
}

/**
 * Payments payment method mapper
 */
export const mapperPaymentsPaymentMethod = (data: any, getUrl: Function) => {
  if (!data) {
    return null
  }
  // get full route data to get the url and validate if should be a nuxt link or not
  try {
    const urlData = data?.sys?.id ? { internalLink: { sys: { id: data.pageId } } } : null
    const routeData = getUrl(urlData)

    return {
      id: data?.sys?.id || '',
      name: data?.name || '',
      pageId: data?.pageId || '',
      url: routeData?.url || '',
      isNuxtLink: routeData?.route?.payload?.nuxtLink || false,
      submethodsTitle: data?.submethodsTitle || '',
      submethods: data?.submethodCollection?.items?.map(mapperPaymentsPaymentSubmethod) || [],
      shortDescription: data?.shortDescription || '',
      description: data?.description || {},
      image: mapperModuleMedia(data.image, {}),
      paymentMethodTypes: data?.paymentMethodTypeCollection?.items?.map(mapperGlobalDataPaymentMethodType) || [],
      paymentMethodTypesNames:
        data?.paymentMethodTypeCollection?.items
          ?.filter(Boolean)
          .map((i) => i.name)
          ?.join(', ') || '',
      processingCurrencyAll: data?.processingCurrencyAll || false,
      processingCurrencyInfo: data?.processingCurrencyInfo || '',
      settlementCurrencyAll: data?.settlementCurrencyAll || false,
      settlementCurrencyInfo: data?.settlementCurrencyInfo || '',
      processingCurrencies: getCurrencies(data?.processingCurrencyCollection?.items, data?.processingCurrencyAll),
      settlementCurrencies: getCurrencies(data?.settlementCurrencyCollection?.items, data?.settlementCurrencyAll),
      features: [
        { name: 'refunds', value: mapperBoolean(data?.refunds), text: data?.refundsInfo || '' },
        { name: 'partialRefunds', value: mapperBoolean(data?.partialRefunds), text: data?.partialRefundsInfo || '' },
        {
          name: 'multiplePartialRefunds',
          value: mapperBoolean(data?.multiplePartialRefunds),
          text: data?.multiplePartialRefundsInfo || ''
        },
        {
          name: 'multiplePartialCaptures',
          value: mapperBoolean(data?.multiplePartialCaptures),
          text: data?.multiplePartialCapturesInfo || ''
        },
        { name: 'secure3D', value: mapperBoolean(data?.secure3D), text: data?.secure3DInfo || '' },
        { name: 'chargeback', value: mapperBoolean(data?.chargeback), text: data?.chargebackInfo || '' },
        { name: 'entityRequired', value: mapperBoolean(data?.entityRequired), text: data?.entityRequiredInfo || '' },
        { name: 'salesDayPayout', value: mapperBoolean(data?.salesDayPayout), text: data?.salesDayPayoutInfo || '' },
        { name: 'settlementDelay', value: data?.settlementDelay || null, text: '' },
        { name: 'recurring', value: mapperBoolean(data?.recurring), text: data?.recurringInfo || '' }
      ],
      countryData: data?.countryData || null,
      pricingData: {
        feeExplanationTitle: data.pricingFeeExplanationTitle || '',
        feeExplanationText: data.pricingFeeExplanationText || '',
        refundFeeExplanationTitle: data.pricingRefundFeeExplanationTitle || '',
        refundFeeExplanationText: data.pricingRefundFeeExplanationText || '',
        isFeeTypeInterchange: data.pricingFeeTypeInterchange,
        isCountryGlobal: mapperBoolean(data.pricingSetShopperCountryGlobal),
        fee: data.pricingFee || '',
        refundFee: data.pricingRefundFee || '',
        countryFees:
          data.pricingFeeCountryTable && data.pricingFeeCountryTable.length > 0 ? data.pricingFeeCountryTable : []
      }
    }
  } catch (e) {
    console.error(e)
  }
}
